import * as React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FaqAccordian = () => {
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (_, isExpanded) =>
    setExpanded(isExpanded ? panel : false);

  const faqs = [
    {
      id: "panel1",
      question: "What does Kloudscan do, and why do I need it?",
      answer:
        "Kloudscan helps remove your personal information from data brokers, people search sites, and other websites that collect and sell your data. This reduces your online exposure and improves your privacy.",
    },
    {
      id: "panel2",
      question: "How does the removal process work?",
      answer:
        "Once you sign up, select a subscription, and authorize us to act on your behalf, we immediately begin contacting companies that hold your personal information to request its removal.",
    },
    {
      id: "panel3",
      question: "Which data brokers do you contact?",
      answer:
        "We don’t publicly share a fixed list since it’s constantly evolving. However, you can view all companies we contact in real time through your dashboard. We are continuously expanding our coverage.",
    },
    {
      id: "panel4",
      question:
        "How can I track my removal requests and see what has been deleted?",
      answer:
        "You’ll have access to a personal dashboard where you can track every step — including when requests are sent, received, and completed.",
    },
    {
      id: "panel5",
      question: "Will this stop all spam, robocalls, and data leaks?",
      answer:
        "Data removal is an ongoing process. While we significantly reduce your exposure, we cannot guarantee the complete elimination of spam, robocalls, or data leaks.",
    },
    {
      id: "panel6",
      question: "How long does the removal process take, and is it permanent?",
      answer:
        "Most companies are required to respond within 45 days under regulations like CCPA, with possible extensions up to 90 days. Data removal is not always permanent, so ongoing monitoring is important.",
    },
    {
      id: "panel7",
      question: "Can I cancel anytime?",
      answer:
        "Yes, you can cancel your subscription at any time in the dashboard. We also offer a 30-day money-back guarantee for new subscribers.",
    },
    {
      id: "panel8",
      question: "How do I get help or contact customer support?",
      answer: (
        <>
          You can contact our support team at{" "}
          <strong>support@kloudscan.com</strong>
        </>
      ),
    },
  ];

  return (
    <Box
      component="section"
      sx={{ py: 8, width: "100%", backgroundColor: "white" }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Grid
          container
          spacing={6}
          alignItems="flex-start"
          justifyContent="center"
        >
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 900,
                mb: 2,
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Answers to Your Most Common Questions
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 8 }}>
            {faqs.map(({ id, question, answer }) => (
              <Accordion
                key={id}
                expanded={expanded === id}
                onChange={handleChange(id)}
                disableGutters
                square
                sx={{
                  boxShadow: "none",
                  "&::before": { display: "none" },
                  backgroundColor: "transparent",
                  borderBottom: "2px solid #ddd",
                  transition: "border-color 0.25s ease",
                  "&.Mui-expanded": {
                    borderBottom: "2px solid #12b2f1",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`${id}-content`}
                  id={`${id}-header`}
                  sx={{
                    minHeight: 48,
                    "&.Mui-expanded": { minHeight: 48 },
                    px: 0,
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    {question}
                  </Typography>
                </AccordionSummary>

                <AccordionDetails sx={{ py: 1, px: 0 }}>
                  <Typography variant="body2" color="text.secondary">
                    {answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default FaqAccordian;
